import { jsx as r } from "react/jsx-runtime";
const s = ({ children: o }) => /* @__PURE__ */ r("div", { className: "grid grid-cols-[auto_1fr] gap-x-4 gap-y-1", children: o });
export {
  s as InfoColumn
};
